import { useQuery } from "@tanstack/react-query";
import { getBrandPreview } from "src/api/home";
export const useBrandPreviewQuery = (param)=>{
    let { brandPreviewId , enabled =true  } = param;
    return useQuery({
        queryKey: [
            "brandPreview",
            brandPreviewId
        ],
        queryFn: ()=>getBrandPreview(brandPreviewId),
        enabled: enabled && brandPreviewId > 0
    });
};
